import styled from 'styled-components'
import { Colors } from 'src/resources/colors'
import { fontFamily, fontSizes } from 'src/resources/typography'
import { themed } from '../fragments/ThemeWrapper'

const Circle = styled.div`
  height: 7.75rem;
  width: 7.75rem;

  border: 4px solid ${themed('circleColor')};
  border-radius: 50%;
  filter: drop-shadow(0px 4px 24px ${themed('circleColor')});

  display: flex;
  justify-content: center;
  align-items: center;

  margin-left: auto;
  margin-right: auto;
  margin-bottom: 18px;

  font-family: ${fontFamily.fontPrimary};
  font-size: ${fontSizes.type24};
  font-weight: 600;
  color: ${Colors.textLogo};

  text-align: center;

  img {
    border-radius: 50%;
    height: 100px;
    width: 100px;
  }
`

interface ILogoAvatar {
  logo?: string
  name?: string
}

export function LogoAvatar({ logo, name }: ILogoAvatar) {
  return <Circle>{logo ? <img src={logo} /> : name}</Circle>
}
